import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import SelectSearch from "react-select-search";
import moment from "moment";
import {
  Row,
  Col,
  Input,
  FormText,
  Button,
  FormGroup,
  Label,
} from "reactstrap";

import QuestionnaireModal from "./QuestionnaireModal";
import staffService from "../../services/staffService";
import questionnaireService from "../../services/questionnaireService";
import staffActions from "../../actions/staffActions";
import alertActions from "../../actions/alertActions";
import staffConstants from "../../constants/staffConstants";

const UpdateLitigantInfo = () => {
  const alert = useSelector((state) => state.alert);
  const dispatch = useDispatch();
  const { register, handleSubmit, errors, reset, getValues } = useForm();

  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState({ id: "0" });
  const [selectedLit, setSelectedLit] = useState([]);
  const [getUsers, setGetUsers] = useState("get");
  const [questionnaireButton, setQuestionnaireButton] = useState({
    color: "primary",
    msg: "New Questionnaire",
    id: 0,
  });
  const defaultFormState = {
    firstName: "",
    lastName: "",
    dob: "",
    userName: "",
    phoneNumber: "",
    token: "0",
    tokenExp: moment().format(),
  };

  useEffect(() => {
    if (getUsers === "get") {
      //console.log("--------");
      staffService.getUsers().then((payload) => {
        setUsers(payload);
        let renamedArray = payload.map((a) => {
          return {
            name: a.lastName + ", " + a.firstName,
            value: a.id,
            lit: { ...a },
          };
        });

        renamedArray.unshift({
          name: "Enter new litigant",
          value: "0",
          lit: {},
        });

        setSelectedLit(renamedArray);
      });
      setGetUsers("set");
    }
  }, []);

  useEffect(() => {
    reset(defaultFormState);
  }, []); //If we pass an empty array to useEffect, it’s only executed after the first render.

  useEffect(() => {
    if (Object.keys(alert).length !== 0) {
      //console.log(alert);
      if (alert.altType === staffConstants.REGISTER_SUCCESS) {
        reset(defaultFormState);
        setGetUsers("get");
      }
      if (alert.altType === staffConstants.UPDATE_USER_INFO_SUCCESS) {
        setGetUsers("get");
      }
    }
  }, [alert, reset, defaultFormState]);

  const onSelect = (evt) => {
    const formValues = getValues();
    const value = evt;

    setSelected({ ...selected, id: value });
    if (value !== "0") {
      const user = users.find((user) => user.id === value);
      //console.log(user);
      const newValues = {
        ...{ ...formValues, ...user },
        token: value,
        dob: moment(user.dob).format("MM/DD/YYYY"),
        tokenExp: moment().format(),
      };
      reset(newValues);
      getQuestionnaireButton(value);
      return;
    }
    reset(defaultFormState);
  };

  const getQuestionnaireButton = (value) => {
    questionnaireService.checkForQuestionnaire(value).then((color) => {
      if (parseInt(color.id) === 0) {
        setQuestionnaireButton({
          ...questionnaireButton,
          color: "primary",
          id: color.id,
          msg: "New questionnaire",
        });
      }
      if (parseInt(color.id) < 0) {
        setQuestionnaireButton({
          ...questionnaireButton,
          color: "danger",
          id: color.id,
          msg: "Errors found",
        });
      }
      if (parseInt(color.id) >= 1) {
        setQuestionnaireButton({
          ...questionnaireButton,
          color: "info",
          id: color.id,
          msg: "View/Edit questionnaire",
        });
      }
    });
  };

  const onSubmit = (data) => {
    const fs = { ...data, dob: moment(data.dob).format() };
    if (fs.token === "0") {
      dispatch(
        staffActions.register(
          fs.dob,
          fs.firstName,
          fs.lastName,
          fs.userName,
          fs.phoneNumber
        )
      );
    } else {
      dispatch(staffActions.updateUserInfo(fs));
    }
    //console.log(fs);
  };

  const onButtonReset = () => {
    const formValue = getValues("userName");
    dispatch(alertActions.notice("Submitting password reset request"));
    const email = { email: formValue };
    staffService.resetPasswordRequest(email).then(() => {
      dispatch(
        alertActions.success("Successfully sent password reset request.")
      );
    });
    return;
  };
  //const size = users.length + 1;
  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <h2>Update litigant personal info</h2>
        </Col>
        <hr />
      </Row>
      <Row>
        <Col md={3}>
          <FormGroup row>
            <Col sm={12}>
              <SelectSearch
                options={selectedLit}
                value={selected.id}
                search={true}
                name="select"
                placeholder="Choose a litigant"
                onChange={(id) => onSelect(id)}
                printOptions="always"
              />
            </Col>
          </FormGroup>
        </Col>
        <Col md={9}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup row>
              <Label sm={12}>First name</Label>
              <Input type="hidden" innerRef={register} name="token" />
              <Input type="hidden" innerRef={register} name="tokenExp" />
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="text"
                    name="firstName"
                    style={{ width: "90%" }}
                    innerRef={register({
                      required: true,
                      minLength: 2,
                    })}
                    autoComplete="off"
                    placeholder="First name"
                    className={errors?.firstName ? "custError" : ""}
                  />
                  <FormText>
                    Enter your first name.{" "}
                    {errors?.firstName?.type === "required" && (
                      <i style={{ color: "red" }}> First name is required.</i>
                    )}
                    {errors?.firstName?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </React.Fragment>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={12}>Last name</Label>
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="text"
                    name="lastName"
                    style={{ width: "90%" }}
                    innerRef={register({
                      required: true,
                      minLength: 2,
                    })}
                    autoComplete="off"
                    placeholder="Last name"
                    className={errors?.lastName ? "custError" : ""}
                  />
                  <FormText>
                    Enter your last name.{" "}
                    {errors?.lastName?.type === "required" && (
                      <i style={{ color: "red" }}> Last name is required.</i>
                    )}
                    {errors?.lastName?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </React.Fragment>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={12}>DOB</Label>
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="text"
                    name="dob"
                    style={{ width: "90%" }}
                    innerRef={register({
                      required: true,
                      pattern: {
                        value: /(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d/,
                        message: "Please enter a valid date MM/DD/YYYY.",
                      },
                    })}
                    placeholder="MM/DD/YYYY"
                    className={errors?.dob ? "custError" : ""}
                  />
                  <FormText>
                    Enter your DOB.{" "}
                    <i style={{ color: "red" }}>
                      {errors.dob && errors.dob.message}
                    </i>
                    {errors?.dob?.type === "required" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Date of birth is required.
                      </i>
                    )}
                  </FormText>
                </React.Fragment>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={12}>Email</Label>
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="text"
                    name="userName"
                    style={{ width: "90%" }}
                    innerRef={register({
                      required: true,
                      minLength: 3,
                      maxLength: 256,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Please enter a valid email address.",
                      },
                    })}
                    autoComplete="off"
                    placeholder="E-mail"
                    className={errors?.userName ? "custError" : ""}
                  />
                  <FormText>
                    Enter an email.{" "}
                    <i style={{ color: "red" }}>
                      {errors.userName && errors.userName.message}
                    </i>
                    {errors?.userName?.type === "required" && (
                      <i style={{ color: "red" }}> Email required.</i>
                    )}
                    {errors?.userName?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </React.Fragment>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={12}>Phone number</Label>
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="text"
                    name="phoneNumber"
                    style={{ width: "90%" }}
                    innerRef={register({
                      required: true,
                      pattern: {
                        value: /^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
                        message: "Enter a valid phone number",
                      },
                    })}
                    placeholder="Phone number ###-###-####"
                    className={errors?.phoneNumber ? "custError" : ""}
                    autoComplete="off "
                  />
                  <FormText>
                    Enter a phone number.
                    <i style={{ color: "red" }}>
                      {errors.phoneNumber && errors.phoneNumber.message}
                    </i>
                    {errors?.phoneNumber?.type === "required" && (
                      <i style={{ color: "red" }}> Phone number is required.</i>
                    )}
                  </FormText>
                </React.Fragment>
              </Col>
            </FormGroup>
            <Button type="submit">Submit</Button>{" "}
            {selected.id !== "0" && (
              <Button
                className="bgBlue"
                type="button"
                onClick={() => onButtonReset()}
              >
                Send Password reset
              </Button>
            )}{" "}
            {selected.id !== "0" && (
              <QuestionnaireModal
                buttonLabel={questionnaireButton.msg}
                userId={selected.id}
                qId={questionnaireButton.id}
                color={questionnaireButton.color}
                hasCurrentQuestionnaire={
                  parseInt(questionnaireButton.id) > 0 ? true : false
                }
                modalTitle={questionnaireButton.msg}
                getQuestionnaireButton={getQuestionnaireButton}
              />
            )}
          </form>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default UpdateLitigantInfo;
